import React from 'react'
import Container from 'react-bootstrap/Container'
import { Col, Collapse, Row } from 'react-bootstrap'
import UploadFileContainer from './UploadFileContainer'
import InvoiceListsBlock from './InvoiceListsBlock'
import InvoiceDetailsBlock from './InvoiceDetailsBlock'
import InvoiceFileViewerBlock from './InvoiceFileViewerBlock'
import { useInvoiceProcessing } from '../hooks/useInvoiceProcessing'

const InvoiceProcessing = () => {
	const { isSuccess, isEmpty } = useInvoiceProcessing()

	return (
		<div>
			<Container style={{ maxWidth: '1500px' }} className="p-2">
				<UploadFileContainer />
				<Collapse className="mt-4 h-100" in={isSuccess && !isEmpty}>
					<Row>
						<Col xs={4}>
							<InvoiceListsBlock />
						</Col>
						<Col xs={4}>
							<InvoiceDetailsBlock />
						</Col>
						<Col xs={4}>
							<InvoiceFileViewerBlock />
						</Col>
					</Row>
				</Collapse>
			</Container>
		</div>
	)
}

export default InvoiceProcessing
